import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import React from 'react';
import { AssetSummaryScreen } from 'screens/AssetScreen/AssetSummaryScreen';

import { AssetExplorer } from './AssetExplorer';
import { ComplianceSummaryScreen } from './Compliance/ComplianceSummaryScreen';
import { FieldRepeatableStack } from './Field/FieldRepeatableStack';
import { FieldStandardInstanceScreen } from './Field/FieldStandardInstanceScreen';

const StackNavigator =
  createNativeStackNavigator<NavigationStacks[Stacks.ASSET]>();

export const AssetStack: React.FC<{
  assetId: string;
  externalExplorer?: boolean;
}> = ({ assetId, externalExplorer }) => (
  <StackNavigator.Navigator
    initialRouteName={
      externalExplorer ? Screens.ASSET_SUMMARY : Screens.ASSET_EXPLORER
    }
    screenOptions={{
      animation: externalExplorer ? 'none' : 'default',
      headerShown: false,
    }}
  >
    <StackNavigator.Screen
      name={Screens.ASSET_EXPLORER}
      component={AssetExplorer}
      initialParams={{ assetId }}
    />
    <StackNavigator.Screen
      name={Screens.ASSET_SUMMARY}
      component={AssetSummaryScreen}
      initialParams={{ assetId }}
    />
    <StackNavigator.Screen
      name={Screens.ASSET_COMPLIANCE}
      component={ComplianceSummaryScreen}
    />
    <StackNavigator.Screen
      name={Screens.ASSET_FIELDSTANDARD}
      component={FieldStandardInstanceScreen}
    />
    <StackNavigator.Screen
      name={Screens.ASSET_FIELDREPEATABLE}
      component={FieldRepeatableStack}
    />
  </StackNavigator.Navigator>
);
